import './info.css';
import {
  Dates,
  Schedule,
  Address,
} from './components';

function Info() {
  return (
    <div className='info--container'>
      <div className='info--schedule-wrapper'>
        <Dates />
        <Schedule />
      </div>
      <Address />
    </div>
  );
}

export default Info;
